import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { FartherAccountId, TransferId } from "../../Types";
import ValidationError from "../../ZodError";
export const WithdrawalBody = z.object({
    sourceVirtualAccountId: FartherAccountId,
    amount: z.number().min(0.01, "Must be at least 1 cent").nullable(), // null for full liquidations
});
const Response = z.object({ transferId: TransferId, message: z.string() });
export const url = () => environment() === "PROD"
    ? "https://middleware.prod.farther.com/transfer/v2/transfers/ach/withdrawal"
    : "https://middleware.uat.farther.com/transfer/v2/transfers/ach/withdrawal";
export default async function createACHWithdrawal(withdrawal, config) {
    const validated = WithdrawalBody.safeParse({
        sourceVirtualAccountId: withdrawal.fartherAccountId,
        amount: withdrawal.amount,
    });
    if (!validated.success) {
        throw new ValidationError("createACHWithdrawal got bad body", validated.error.issues);
    }
    const { data } = await axios.post(url(), validated.data, {
        headers: {
            Client: config.clientId,
            Authorization: `Bearer ${config.jwt}`,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "createACHWithdrawal returned unexpected data.";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=createACHWithdrawal.js.map